export const SEARCH_DEBOUNCE = 1000;
export const OFFSET_STEP = 50;
export const CHIPS_LIMIT = 50;
